import React from 'react';
import { TextField } from '@material-ui/core';
import TimeField from 'react-simple-timefield';

const pad = (n: number, width: number, z: string = '0') => {
  z = z || '0';
  let nStr = n.toString()
  return nStr.length >= width ? n : new Array(width - nStr.length + 1).join(z) + n;
}

export const secondsToHms = (s : number) => {
  const seconds = Math.floor(s % 60);
  const minutes = Math.floor((s / 60) % 60);
  const hours = Math.floor((s / 3600));

  return pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
}

const hmsToSeconds = (hms: string) => {
  return Number(hms.split(':')[0]) * 3600 + Number(hms.split(':')[1]) * 60 + Number(hms.split(':')[2]);
}

type Props = {
  className: any,
  timeSeconds: number,
  onTimeChanged?: (seconds: number) => void,
};

const TimeInputField = (props: Props) => {
  const {
    className,
    timeSeconds,
    onTimeChanged,
  } = props;

  return (
    <TimeField
      showSeconds
      value={secondsToHms(timeSeconds)}
      onChange={(e, hms) => {
        onTimeChanged && onTimeChanged(hmsToSeconds(hms));
      }}
      style={{minWidth: 93, width: 93}}
      input={
        <TextField 
          InputProps={{
            className: className,
          }}
          disabled={onTimeChanged === undefined}
        />
      }
    />
  )
}

export default TimeInputField;